import { Vcdm11Flavor } from './flavor/vcdm1_1';
import { Vcdm20Flavor } from './flavor/vcdm2_0';
import type {
    CredentialBlob,
    CredentialClaims,
    CredentialMetadata,
    CredentialSchema,
    DocumentFlavor,
    Flavor,
} from './types';

export class CredentialFlavor implements Flavor {
    private supportedFlavors: DocumentFlavor[] = [new Vcdm11Flavor(), new Vcdm20Flavor()];

    private async matchFlavor(blob: CredentialBlob): Promise<DocumentFlavor | undefined> {
        for (const flavor of this.supportedFlavors) {
            if (await flavor.isOfFlavor(blob)) return flavor;
        }
        return undefined;
    }

    private async getFlavor(blob: CredentialBlob): Promise<DocumentFlavor> {
        const blobFlavor = await this.matchFlavor(blob);

        if (!blobFlavor) {
            const knownFlavorKinds = this.supportedFlavors.map((flavor) => flavor.kind);
            throw new Error(`Received blob does not match any known flavors: ${knownFlavorKinds}`);
        }

        return blobFlavor;
    }

    async getClaims(blob: CredentialBlob): Promise<CredentialClaims> {
        const flavor = await this.getFlavor(blob);
        return flavor.getClaims(blob);
    }

    async getMetadata(blob: CredentialBlob): Promise<CredentialMetadata> {
        const flavor = await this.getFlavor(blob);
        return flavor.getMetadata(blob);
    }

    async getSchema(blob: CredentialBlob): Promise<CredentialSchema | undefined> {
        const flavor = await this.getFlavor(blob);
        return flavor.getSchema(blob);
    }
}
